import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/dashboard/page";
import TapesPage from "@/pages/tapes/page";
import BoxesPage from "@/pages/boxes/page";
import LibraryPage from "@/pages/library/page";
import ImportExportPage from "@/pages/import/page";
import BackupPage from "@/pages/backup/page";
import ReplacementPage from "@/pages/replacement/page";
import DamagedPage from "@/pages/damaged/page";
import AccountsPage from "@/pages/accounts/page";
import LogsPage from "@/pages/logs/page";
import LoginPage from "@/pages/auth/Login";

const routes: RouteObject[] = [
  { path: "login", element: <LoginPage /> },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: "tapes", element: <TapesPage /> },
      { path: "boxes", element: <BoxesPage /> },
      { path: "library", element: <LibraryPage /> },
      { path: "import", element: <ImportExportPage /> },
      { path: "backup", element: <BackupPage /> },
      { path: "replacement", element: <ReplacementPage /> },
      { path: "damaged", element: <DamagedPage /> },
      { path: "logs", element: <LogsPage /> },
      { path: "accounts", element: <AccountsPage /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;